// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"CheckboxInput_checkboxWrapper__jJZsB","checkmark":"CheckboxInput_checkmark__6I8uJ"};